import CryptoJS from "crypto-js";

// Secret key from environment variables
const secretKey = import.meta.env.VITE_TOKEN_KEY;
if (!secretKey) {
  throw new Error("VITE_TOKEN_KEY is not defined.");
}

// Encrypt permissions data
export const encryptPermissionData = (permissions) => {
  const stringData = JSON.stringify(permissions);
  return CryptoJS.AES.encrypt(stringData, secretKey).toString();
};

// Decrypt permissions data
export const decryptPermissionData = (encryptedPermissions) => {
  const bytes = CryptoJS.AES.decrypt(encryptedPermissions, secretKey);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};

// Store encrypted permissions
export const storePermissions = (permissions) => {
  const encryptedPermissions = encryptPermissionData(permissions);
  localStorage.setItem("permissions", encryptedPermissions);
};

// Retrieve and decrypt permissions
export const retrievePermissions = () => {
  const encryptedPermissions = localStorage.getItem("permissions");
  if (!encryptedPermissions) {
    return null;
  }

  try {
    return decryptPermissionData(encryptedPermissions);
  } catch (error) {
    return null;
  }
};

// Store a token
export const storeToken = (name, token) => {
  localStorage.setItem(name, token);
};

// Retrieve a token
export const retrieveToken = (name) => {
  return localStorage.getItem(name);
};

export const storeUserData = (data) => {
  localStorage.setItem("user", data);
};

export const retrieveUserData = () => {
  const userData = localStorage.getItem("user");
  if (!userData) {
    console.log("No user data found in localStorage.");
    return null;
  }
  try {
    const parsedData = JSON.parse(userData);
    return parsedData;
  } catch (error) {
    console.error("Error parsing user data:", error);
    return null;
  }
};
